import { LANGUAGES } from '.';
var DEFAULT_LANGUAGE = 'en';
export default function parseLanguage(input) {
  if (!input) {
    return DEFAULT_LANGUAGE;
  }
  var formattedInput = input.replace('-', '_');
  if (LANGUAGES.includes(formattedInput)) {
    return formattedInput;
  }
  var languagePart = formattedInput.substring(0, 2);
  if (LANGUAGES.includes(languagePart)) {
    return languagePart;
  }
  return DEFAULT_LANGUAGE;
}